import { useState, useCallback } from 'react';

const INITIAL_FORM_DATA = {
  plano: '',
  tipoFluxo: '1',
  tipoCorrecao: 'SemCorrecao',
  quantidadeParcelas: 0,
  ato: '0',
  e2: '0',
  e3: '0',
  aumento: '0',
  desconto: '0',
  fgts: '0',
  renda: '0',
  carteira: '0',
  cartaDeCredito: false,
  valorCartaDeCredito: '0',
  eSAD: false,
  balaDePrata: false,
  entradaFacilitada: false,
  padraoPsa: '0',
  percentualEntrada: '',
  saldoDevedor: '',
  parcelaEntrada: '',
  parcelaFinanciamento: '',
  totalParcela: ''
};

/**
 * Hook para gerenciar estado do formulário
 * @returns {Object} Estado e ações do formulário
 */
export const useFormManagement = () => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [intermediates, setIntermediates] = useState([]);

  /**
   * Método centralizado para trocar de plano e limpar todos os campos relacionados
   */
  const handlePlanoChange = useCallback((novoPlano) => {
    setFormData(prev => ({
      ...prev,
      plano: novoPlano,
      ato: '0',
      e2: '0',
      e3: '0',
      eSAD: false,
      fgts: '0',
      quantidadeParcelas: 0,
      aumento: '0',
      desconto: '0',
      renda: '0',
      carteira: '0',
      padraoPsa: '0'
    }));
    setIntermediates([]);
  }, []);

  const resetForm = useCallback(() => {
    setFormData(INITIAL_FORM_DATA);
    setIntermediates([]);
  }, []);

  const handleIntermediatesChange = useCallback((newIntermediates) => {
    setIntermediates(newIntermediates);
  }, []);

  return {
    formData,
    setFormData,
    handlePlanoChange,
    resetForm,
    intermediates,
    handleIntermediatesChange
  };
};
